<template>
  <RsPartialNavigationContainer
    v-if="['lead_tracker', 'call_tracking', 'waitinglist'].find(productKey => $rsGlobals.$userHasAtLeastOneAccess(productKey))"
    :key="variant"
  >
    <RsPartialNavigationTree
      title="Leads"
      icon="far fa-envelope rs-text-tertiary-medium-purple"
      active-icon="fas fa-envelope rs-text-primary"
      icon-size="lg"
      :variant="variant"
      :expanded="expanded"
      :active="routeStartsWith('/leads')"
    >
      <RsPartialNavigationTreeBranch
        v-if="$rsGlobals.$userHasAtLeastOneAccess('lead_tracker')"
        title="Inquiries Log"
        :to="{ name: 'ActiveInquiries' }"
        :active="routeStartsWith('/leads/inquiries')"
      />
      <RsPartialNavigationTreeBranch
        v-if="$rsGlobals.$userHasAtLeastOneAccess('waitinglist')"
        title="Waiting Lists"
        :to="{ name: 'PropertyWaitingLists' }"
        :active="routeEndsWith('/leads/waiting-lists')"
      />
      <RsPartialNavigationTreeBranch v-if="$rsGlobals.$userHasAtLeastOneAccess('call_tracking')">
        <RsPartialNavigationTree title="Call Tracking" :expanded="routeStartsWith('/leads/call-tracking')">
          <RsPartialNavigationTreeBranch
            title="Call Logs"
            :to="{ name: 'CallTrackingLogs' }"
            :active="routeIncludes('/leads/call-tracking/logs')"
          />
          <RsPartialNavigationTreeBranch
            title="Text Messages"
            :to="{ name: 'CallTrackingMessageLogs' }"
            :active="routeIncludes('/leads/call-tracking/message-logs')"
          />
          <RsPartialNavigationTreeBranch
            title="Active Number Summary"
            :to="{ name: 'CallActiveNumberSummary' }"
            :active="routeIncludes('/leads/call-tracking/active-number-summary')"
          />
          <RsPartialNavigationTreeBranch
            title="Forwarding Numbers"
            :to="{ name: 'CallForwarding' }"
            :active="routeIncludes('/leads/call-tracking/call-forwarding')"
          />
          <RsPartialNavigationTreeBranch
            title="Non-Syndicated Numbers"
            :to="{ name: 'CallNonSyndicatedNumbers' }"
            :active="routeIncludes('/leads/call-tracking/non-syndicated-numbers')"
          />
          <RsPartialNavigationTreeBranch
            title="Call and Text Settings"
            :to="{ name: 'CallAndTextSettings' }"
            :active="routeIncludes('/leads/call-tracking/call-and-text-settings')"
          />
          <RsPartialNavigationTreeBranch
            v-if="$rsGlobals.$userHasAtLeastOneAccess('interactive_voice_responses')"
          >
            <RsPartialNavigationTree
              title="IVR"
              :expanded="routeStartsWith('/leads/call-tracking/ivr')"
            >
              <RsPartialNavigationTreeBranch
                title="Properties"
                :to="{ name: 'PropertyIVRSettings' }"
                :active="routeStartsWith('/leads/call-tracking/ivr/properties') && !routeIncludes('/leads/call-tracking/ivr/call-groups')"
              />
              <RsPartialNavigationTreeBranch
                title="Call Groups"
                :to="{ name: 'IVRCallGroups' }"
                :active="routeIncludes('/leads/call-tracking/ivr/call-groups')"
              />
            </RsPartialNavigationTree>
          </RsPartialNavigationTreeBranch>
        </RsPartialNavigationTree>
      </RsPartialNavigationTreeBranch>
    </RsPartialNavigationTree>
  </RsPartialNavigationContainer>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import RsPartialNavigationContainer from '@/components/RsPartialNavigationContainer.vue';
import RsPartialNavigationTree, { NavigationTreeVariantType } from '@/components/RsPartialNavigationTree.vue';
import RsPartialNavigationTreeBranch from '@/components/RsPartialNavigationTreeBranch.vue';
import { routeEndsWith, routeParamExists, routeStartsWith, routeIncludes } from '@/shared/helpers/navigation-active-helpers';

export default defineComponent({
  components: {
    RsPartialNavigationContainer,
    RsPartialNavigationTree,
    RsPartialNavigationTreeBranch,
  },

  props: {
    variant: {
      type: String as PropType<NavigationTreeVariantType>,
      default: 'collapse',
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    routeStartsWith,
    routeEndsWith,
    routeParamExists,
    routeIncludes,
  },
});
</script>
